import React,{ useEffect, useState } from 'react'
import { Link } from 'react-scroll'
import Aos from 'aos';
import 'aos/dist/aos.css';

function SendEmail() {
  const [name,setName] = useState('')
  const [phone,setPhone] = useState('')
  const [email,setEmail] = useState('')
  const [message,setMessage] = useState('')
  const [text,setText] = useState('')
  const [emailSuccess,setEmailSuccess] = useState(false) 

  const confirmBtn = () => {
    setEmailSuccess('false')
    if(name==='' || phone==='' || email==='' || message===''){
       setText('你有資訊沒填')
       return
    }
  
    setName('')
    setPhone('')
    setEmail('')
    setMessage('')
    setEmailSuccess('sending')
    
    fetch("https://formsubmit.co/ajax/editor539808@gmail.com", {
        method: "POST",
        headers: { 
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify({
            '姓名': name,
            '信箱': email,
            '電話': phone,
            '訊息': message
        })
    })
    .then(response => response.json())
    .then(data => {
        //setname null
       
        setEmailSuccess(() => {
            if( data.success === 'true'){
                return 'true'
            }else{
                return 'false'
            }
        })
    })
    .catch(error => console.log(error));
  }

  const emailSuccessContainer = () => {
   if(emailSuccess === 'sending'){
       return (<div className='text-green-500 mb-8'>傳送中...</div>)
   }else if(emailSuccess === 'true'){
       return (<div className='text-green-500 mb-8'>傳送成功，感謝你的來信</div>)
   }else{
       return (<div className='text-red-500 mb-8'>{ text }</div>)
   }
  }
  useEffect(()=>{
    Aos.init({duration: 1000})
  },[])
  return (
    <div className='flex flex-col' >
        <section className='flex justify-center my-12 '>
            <a href="https://www.facebook.com/SunyangCham/">
                <img src="images/fb.png" alt="" className='h-12 w-12  mx-2' />
            </a>
            <a href="tel:+886-07-7038333">
                <img src="images/phone.png" alt="" className='h-12 w-12 mx-2'/>
            </a>
        </section>
        <section className='flex flex-col justify-center items-center' data-aos='flip-left'>
            <input type="text" className='border-2 border-gray-300 rounded-lg lg:w-96 w-4/5 lg:h-12 h-10 my-2' placeholder='姓名' onChange={(e) => setName(e.target.value)} value={name}/>
            <input type="text" className='border-2 border-gray-300 rounded-lg lg:w-96 w-4/5 lg:h-12 h-10 my-2' placeholder='手機' onChange={(e) => setPhone(e.target.value)} value={phone}/>
            <input type="text" className='border-2 border-gray-300 rounded-lg lg:w-96 w-4/5 lg:h-12 h-10 my-2' placeholder='信箱' onChange={(e) => setEmail(e.target.value)} value={email}/>
            <input type="text" className='border-2 border-gray-300 rounded-lg lg:w-96 w-4/5 lg:h-12 h-10 my-2' placeholder='您的留言' onChange={(e) => setMessage(e.target.value)} value={message}/>
            <button className='text-white rounded-full bg-black w-32 h-12 my-8' onClick={confirmBtn}>確定送出</button>
            {
                emailSuccessContainer()
            }
        </section>

      
        <Link className='w-20 h-20 fixed bottom-0 right-0 bg-slate-600 text-white hover:bg-slate-400 mr-10 flex justify-center items-center cursor-pointer'
            to="main"
            spy={true}
            smooth={true}
            offset={0}
            duration={500}
        >
            <span className='font-black'>TOP</span>
        </Link>
        
        
    </div>
  )
}

export default SendEmail